export default __webpack_public_path__ + "static/media/header-bottom-lab.1279030e.png";